import React from "react";
import { Helmet } from "react-helmet";
import defaultThumbnail from "../../images/social-banner.png";

const Seo = ({
  children,
  lang = "en",
  meta = [],
  pageSpecificTitle,
  pageSpecificDescription,
  pageSpecificThumbnail
}) => {
  const description = pageSpecificDescription;
  const thumbnail = pageSpecificThumbnail || defaultThumbnail;
  const thumbnailAlt = pageSpecificTitle;
  const url = `https://parkinsons.eventxlive.com/`;
  const image = `https://parkinsons.eventxlive.com${thumbnail}`;

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={pageSpecificTitle}
        link={[
          {
            rel: "canonical",
            href: url,
          },
        ]}
        meta={[
          {
            property: "og:site_name",
            content: `Parkinson's Ireland National Conference 2024`,
          },
          {
            name: `description`,
            content: `${description}`,
          },
          {
            property: `og:locale`,
            content: "en_GB",
          },
          {
            property: `og:url`,
            content: url,
          },
          {
            property: `og:title`,
            content: `Parkinson's Ireland National Conference 2024`,
          },
          {
            property: `og:description`,
            content: description,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            property: `og:image`,
            content: image,
          },
          {
            property: `og:image:url`,
            content: image,
          },
          {
            property: `og:image:secure_url`,
            content: image,
          },
          {
            property: `og:image:alt`,
            content: thumbnailAlt,
          },
          {
            property: "og:image:width",
            content: "1200",
          },
          {
            property: "og:image:height",
            content: "630",
          },
          {
            name: `twitter:card`,
            content: `summary_large_image`,
          },
          {
            name: `twitter:image`,
            content: image,
          },
          {
            property: "twitter:image:alt",
            content: thumbnailAlt,
          },
          {
            name: `twitter:site`,
            content: '@ParkinsonsIre',
          },
          {
            name: `twitter:creator`,
            content: '@ParkinsonsIre',
          },
          {
            name: `twitter:title`,
            content: `Parkinson's Ireland National Conference 2024`,
          },
          {
            name: `twitter:description`,
            content: `${description}`,
          },
          {
            name: `author`,
            content: 'Agency X - agencyx.ie',
          },
        ].concat(meta)}
      >
        {children}
      </Helmet>
    </>
  );
};

export default Seo;
